import { errorTypes } from '../../types';

// Please prefix all keys with `error` to not get confilcts with other translations.
export default {
	en: {
		error: {
			[errorTypes.pleaseEnterACode]: 'Please enter a code.',
			[errorTypes.unkownCode]: 'You entered an unknown code.',
			[errorTypes.videoNotSupported]: 'Your browser does not support this video.',
			[errorTypes.arNotSuported]:
				'Augmented Reality apps are not supported in a browser, please use the app: %APP_LINKS%',
			[errorTypes.arDescriptionNotLoaded]: 'Error loading Augmented Reality scene description.',
			[errorTypes.languageNotSupported]:
				'The language you selected is not supported. Please try a different one.',
			[errorTypes.unkownArticle]: 'You tried to load an unknown article.',
			[errorTypes.unkownExhibition]: 'You tried to load an unknown exhibition.',
			[errorTypes.viewStateUnkownUiComponent]: 'You tried to open an unknown modal, menu or player.',
			[errorTypes.unkownMediaObject]: 'Unknown media file.',
			[errorTypes.onNativeLoadError]: '',
			[errorTypes.unkownLinkPattern]: 'Sorry, this link does not match anything.',
			[errorTypes.unkownCommand]: 'Unknown command.',
			[errorTypes.augmentedRealityReturnError]: 'The Augmented Reality application returned an error.',
			[errorTypes.geoPositionPermissionDenied]:
				'You disabled the GPS localisation service. Some features will not be avaible to you. Please visit the settings and enable GPS if you want to use them.',
			[errorTypes.geoPositionPositionUnavailable]:
				'GPS localisation service is not available. Please visit the settings and enable GPS to retry.',
			[errorTypes.mapDownloadFailed]: 'Could not download map data. Please reload to try again',
			[errorTypes.articleDownloadFailed]: 'Download of the article failed.',
			[errorTypes.unknownTour]: 'You tried to start an unknown tour.',
			/* eslint-disable quotes */
			[errorTypes.unknownTourArticle]: "The requested article wasn't found in this tour",
			[errorTypes.tourNotActive]: 'No tour active at this moment.',
			[errorTypes.tourInvalidPosition]: 'Tour has no article on this position.',
			[errorTypes.noCaptivePortalExhibitSet]:
				'The captive portal exhibit is not set. Please contact the administrator.',
			[errorTypes.packageSyncerUnkownSubPart]:
				'Unknown sub part of package information . Please contact the administrator.',
			[errorTypes.packageSyncerTourNotDownloaded]:
				'To start this tour, you have to download it beforehand. If the download is currently active, please wait a while and try again.',
			[errorTypes.packageSyncerExhibitionNotDownloaded]:
				'To start this exhibition, you have to download it beforehand.',
			[errorTypes.augmentedRealityEngineVersionMissmatch]:
				'Please update your app to be able to start the Augemented Reality experience.',
			[errorTypes.dataSourceConfigDownloadFailed]: 'Failed downloading the data source config.',
			[errorTypes.dateLocalizationNotAvailable]:
				'The date localization is not available. Please contact the administrator.',
			[errorTypes.packageSyncerDownloadError]:
				'An Error ocurred during content downloading, please check your internet connection and try it again.',
			[errorTypes.packageSyncerDeleteError]: 'An Error ocurred during content deleting',
			[errorTypes.vr360OpenFailed]: 'An Error ocurred while trying to open the 360° image.',
			[errorTypes.landingArticleIdNotSet]:
				'The landing article id is not set. Please contact an administrator to resolve this problem.',
			[errorTypes.failedLoadingStyles]: 'Failed loading the styles. Please contact the administrator.',
			[errorTypes.articleNotInTour]: 'Article is not part of this tour',
			[errorTypes.formIncomplete]: 'Please fill out required fields and press send again.',
			[errorTypes.formSendError]: 'There was an error during sending the data. Please try again.',
			[errorTypes.mqttNotAvailable]:
				'The MQTT interface is not configured. Please contact the administrator.',
			[errorTypes.mapNotConfigured]:
				'There was not map configured. Please contact an administrator to resolve this problem.',
			[errorTypes.cssVersionMissmatch]:
				'The major version of the CSS stylesheet does not match the major version of the webclient. Please contact the administrator.',
			[errorTypes.cssVersionMissing]:
				'The CSS stylesheet version string is missing. Please contact the administrator.',
			[errorTypes.augmentedRealityIndexDownloadFailed]:
				'Loading the augmented reality index.json failed. Please contact the administrator. %ERROR%',
			[errorTypes.nativeApiVersionTooOld]:
				'The app API version is too old. Please contact the administrator.',
			[errorTypes.pwaInitalSync]: 'Downloading content for offline usage.',
		},
	},
	de: {
		error: {
			[errorTypes.pleaseEnterACode]: 'Bitte geben Sie eine Nummer ein.',
			[errorTypes.unkownCode]: 'Sie haben eine unbekannte Nummer eingegeben.',
			[errorTypes.videoNotSupported]: 'Dieses Video wird von Ihrem Browser nicht unterstützt.',
			[errorTypes.arNotSuported]:
				'Augmented-Reality-Anwendungen werden im Browser nicht unterstützt. Bitte benutzen Sie die App: %APP_LINKS%',
			[errorTypes.arDescriptionNotLoaded]:
				'Die Augmented-Reality-Szenenbeschreibung konnte nicht geladen werden.',
			[errorTypes.languageNotSupported]: 'Sie haben eine nicht unterstützte Sprache ausgewählt.',
			[errorTypes.unkownArticle]: 'Sie haben versucht, einen unbekannten Artikel zu laden.',
			[errorTypes.unkownExhibition]: 'Sie haben versucht, eine unbekannte Ausstellung zu laden.',
			[errorTypes.viewStateUnkownUiComponent]:
				'Sie haben versucht, ein unbekanntes Menü, Modal oder Player zu öffnen.',
			[errorTypes.unkownMediaObject]: 'Diese Mediendatei ist nicht bekannt.',
			[errorTypes.onNativeLoadError]: '',
			[errorTypes.unkownLinkPattern]: 'Entschuldigung, dieser Link passt zu nichts Bekanntem.',
			[errorTypes.unkownCommand]: 'Unbekannter Befehl.',
			[errorTypes.augmentedRealityReturnError]:
				'Die Augmented Reality Anwendung hat einen Fehler verursacht.',
			[errorTypes.geoPositionPermissionDenied]:
				'Sie haben den GPS Ortungsservice deaktiviert. Einige Funktionen dieser Anwendung sind daher nicht für Sie verfügbar. Bitte gehen Sie zu den Einstellungen falls sie dies ändern wollen.',
			[errorTypes.geoPositionPositionUnavailable]:
				'Der GPS-Ortungservice ist nicht verfügbar. Bitte gehen Sie zu den Einstellungen, um GPS anzuschalten und es erneut zu versuchen.',
			[errorTypes.mapDownloadFailed]:
				'Die Karte konnte nicht geladen werden. Bitte laden Sie die Anwendung erneut.',
			[errorTypes.articleDownloadFailed]: 'Der Artikel konnte nicht heruntergeladen werden.',
			[errorTypes.unknownTour]: 'Sie haben versucht, eine unbekannte Tour zu starten.',
			[errorTypes.unknownTourArticle]: 'Der gewünschte Artikel wurde in dieser Tour nicht gefunden.',
			[errorTypes.tourNotActive]: 'Momentan ist keine Tour aktiv.',
			[errorTypes.tourInvalidPosition]: 'Tour hat keinen Artikel an dieser Position.',
			[errorTypes.noCaptivePortalExhibitSet]:
				'Das Captive Portal wurde nicht konfiguriert. Bitte verständigen Sie den Administrator.',
			[errorTypes.packageSyncerUnkownSubPart]:
				'Unbekannte Inhaltsgruppe. Bitte verständigen Sie den Administrator.',
			[errorTypes.packageSyncerTourNotDownloaded]:
				'Um diese Tour zu starten, laden Sie sie herunter. Falls der Download gerade aktiv ist, warten Sie bitte etwas und probieren es wieder.',
			[errorTypes.packageSyncerExhibitionNotDownloaded]:
				'Um diese Austellung zu starten, laden Sie sie herunter.',
			[errorTypes.augmentedRealityEngineVersionMissmatch]:
				'Bitte updaten Sie ihre App, um dieses Augmented-Reality-Erlebnis starten zu können.',
			[errorTypes.dataSourceConfigDownloadFailed]: 'Failed downloading the data source config.',
			[errorTypes.dateLocalizationNotAvailable]:
				'The date localization is not available. Please contact the administrator.',
			[errorTypes.packageSyncerDownloadError]:
				'Fehler beim Herunterladen der Inhalte. Bitte überprüfen Sie ihre Internetverbindung und versuchen Sie es erneut.',
			[errorTypes.packageSyncerDeleteError]: 'Fehler beim löschen von Inhalten.',
			[errorTypes.vr360OpenFailed]: 'Fehler beim Öffnen des 360° Bildes.',
			[errorTypes.landingArticleIdNotSet]:
				'Die Landing Article ID ist nicht gesetzt. Bitte wenden Sie sich an einen Administrator, um dieses Problem zu lösen.',
			[errorTypes.failedLoadingStyles]:
				'Beim laden des Styles ist ein Fehler aufgetreten, bitte informieren sie den Administrator.',
			[errorTypes.articleNotInTour]: 'Article ist nicht Teil dieser Tour',
			[errorTypes.formIncomplete]:
				'Bitte füllen sieh die fehlenden Felder aus und drücken sich nochmals auf senden',
			[errorTypes.formSendError]:
				'Es trat leider ein Fehler beim Absenden der Daten auf. Bitte versuchen Sie es noch einmal.',
			[errorTypes.mqttNotAvailable]:
				'Die MQTT Schnittstelle ist nicht eingerichtet. Bitte informieren sie den Administrator.',
			[errorTypes.mapNotConfigured]:
				'Es wurde keine Karte konfiguriert. Bitte informieren sie den Administrator.',
			[errorTypes.cssVersionMissmatch]:
				'Die Major-Version des CSS-Stylesheets stimmt nicht mit der Major-Version des Webclients überein. Bitte informieren sie den Administrator.',
			[errorTypes.cssVersionMissing]:
				'Die CSS-Stylesheet Version fehlt. Bitte kontaktieren Sie den Administrator.',
			[errorTypes.augmentedRealityIndexDownloadFailed]:
				'Das Laden von Augmented Reality index.json ist fehlgeschlagen. Bitte kontaktieren Sie den Administrator. %ERROR%',
			[errorTypes.nativeApiVersionTooOld]:
				'Die App API version ist zu alt. Bitte kontaktieren Sie den Administrator.',
			[errorTypes.pwaInitalSync]: 'Herunterladen von Inhalten zur Offline-Verwendung.',
		},
	},
};
